import PencilIcon from '@atlaskit/icon-lab/core/pencil';
import * as React from 'react';

export function SvgEditBorder() {
  return <PencilIcon label="" testId="ads-refreshed-icon" />;
}
